// import router from '@/router'

import { AuthService } from "../../services/auth.service";
import $router from "../../router";

export default {
  namespaced: true,
  state: {
    accessTokenExpDate: "",
    token: "",
  },
  actions: {
    logout({ commit }, is403 = false) {
      commit("LOGOUT", is403);
    },
  },
  mutations: {
    SET_ATOKEN_EXP_DATE(state, expDate) {
      state.accessTokenExpDate = expDate;
    },
    SET_TOKEN(state, token) {
      state.token = token;
    },
    async LOGOUT(state, is403) {
      await AuthService.logout()
        .finally((s) => {
          state.user = null;
          state.token = null;
          localStorage.removeItem("userData");
          localStorage.removeItem("token");
          localStorage.removeItem("dataPermission");
          return s;
        })
        .finally((s) => {
          // if (is403) $router.push({ name: "403" });
          $router.push({ name: "login" });
        });
    },
  },
};
